import React, { useEffect, useState } from "react";
import { Button } from "../../components/ui/button";
import { toast, ToastContainer } from "react-toastify";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTrigger,
} from "../../components/ui/dialog";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { getAllUml, URL } from "../../lib/apis";
import useStoreDeliveryUser from "../../store/addresse/deliveryUser";
import CustomButton from "../../components/customButton";
import Add_address_modal from "../livraison/Add_address_modal";
import Breadcrumb from "../../components/Breadcrumb";
import { Trash2 } from "lucide-react";
import { scrollToTop } from "../../lib/utils";
import { GeoCollection, SearchResult } from "./geo/type";
import { GeoSearch } from "./geo/GeoSearch";

interface AnotherOrder {
  another_product_name: "",
  another_product_quantity: "",
  another_product_type: "",
}

const RecherTrans = () => {
  const OrderId = useParams().id;
  const userId = localStorage.getItem("user");
  const [unites, setUnites] = useState([])
  const [loading, setLoading] = useState(false)
  const location = useLocation()
  const order = location.state
  const [loader, setLoader] = useState(false)
  const { t, i18n } = useTranslation()
  const [selectedOption2, setSelectedOption2] = useState<{ value: any; label: string } | null>({
    value: order?.delivery_id || null,
    label: order ? `${order?.delivery_address}` : "",
  });
  const [open, setOpen] = useState(false);
  const [openMoal, setOpenModal] = useState(false);
  const token = localStorage.getItem("token");
  const [connect, setConnect] = useState(token);
  const [city, setCity] = useState("");
  const [destination, setDestination] = useState(order ? `${order?.delivery_country}/${order?.delivery_city}/${order?.delivery_address}` : "");
  const [delai, setDelais] = useState("");
  const [latestDepartureDate, setLatestDepartureDate] = useState("");
  const [latestArrivalDate, setLatestArrivalDate] = useState("");
  const navigate = useNavigate()


  // const navigate = useNavigate();


  const [anotherOrderDetails, setAnotherOrderDetails] = useState<AnotherOrder[]>([]);

  const [showProductForm, setShowProductForm] = useState(false);

  const { DeliveryUser, fetchDeliveryUser } = useStoreDeliveryUser();
  const [geoData, setGeoData] = useState<GeoCollection | null>(null);


  const handleAnotherOrderDetailsChange = (
    index: number,
    field: string,
    value: string
  ) => {
    const newDetails = [...anotherOrderDetails];
    newDetails[index] = { ...newDetails[index], [field]: value };
    setAnotherOrderDetails(newDetails);
  };

  useEffect(() => {
    fetch('/data/cmr-simplified.geojson')
      .then((res) => res.json())
      .then((data: GeoCollection) => setGeoData(data))
      .catch((err) => console.error('Erreur chargement GeoJSON:', err));
  }, []);

  const handleSelect = (result: SearchResult) => {
    // setSelected(result);
    setCity(result.name);
    console.log('Sélectionné :', result.name, '· centre :', result.centroid);
    // Ici tu peux recentrer une carte Leaflet/Mapbox :
    // map.flyTo([result.centroid[1], result.centroid[0]], 12);
  };

  useEffect(() => {
    scrollToTop()
  }, [])

  const addAnotherProduct = () => {
    setShowProductForm(true);
    setAnotherOrderDetails([
      ...anotherOrderDetails,
      {
        another_product_name: "",
        another_product_quantity: "",
        another_product_type: "",
      },
    ]);
  };
  const updateUnite = async () => {
    setLoader(true)
    try {
      const { data } = await axios.get(`${getAllUml}`)
      setUnites(data)
    } catch (error: any) {
      toast.error(t(i18n.language === "fr" ? error.response.data.message : error.response.data.messageE))
    } finally {
      setLoader(false)
    }
  }
  useEffect(() => {
    setConnect(token)
  }, [token])
  useEffect(() => {
    updateUnite()
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    if (userId) {
      fetchDeliveryUser(userId);
    }
    // eslint-disable-next-line
  }, [userId, token, openMoal]);



  const handleSubmit = async () => {

    //  const orderIds = orderUser.map((order) => order.order_id);
    if (!connect) {
      toast.error(t("connect_vous"))
      return
    }
    if (OrderId === `0` && destination.trim() === "") {
      toast.error(t("error_select_adresse"));
      return
    }
    if (city.trim() === "" || delai.trim() === "" || latestArrivalDate.trim() === "" || latestDepartureDate.trim() === "") {
      toast.error("Veuillez remplir tous les champs");
      return
    }
    if (OrderId === `0` && !anotherOrderDetails.length) {
      toast.error(t("error_add_product_message"));
      return
    }
    let requestData
    if (anotherOrderDetails.length) {
      requestData = {
        user_id: parseInt(userId ?? ""),
        //  order_id: orderResponse?.data.order_id as number,

        order_id: OrderId === `0` ? null : OrderId,

        // requested_price: parseFloat(estimatedPrice),
        depart: city,
        destination: destination,
        delivery_id: selectedOption2?.value,
        delai: delai,
        latest_departure_date: latestDepartureDate,
        latest_arrival_date: latestArrivalDate,
        another_order_details: anotherOrderDetails.map((detail) => ({
          another_product_name: detail.another_product_name,
          another_product_quantity: parseInt(detail.another_product_quantity),
          another_product_type: detail.another_product_type,
        })),
      };
    } else {
      requestData = {
        user_id: parseInt(userId ?? ""),
        //  order_id: orderResponse?.data.order_id as number,

        order_id: OrderId === `0` ? null : OrderId,

        // requested_price: parseFloat(estimatedPrice),
        depart: city,
        destination: destination,
        delai: delai,
        latest_departure_date: latestDepartureDate,
        latest_arrival_date: latestArrivalDate,
      }
    }


    setLoading(true)
    try {
      const config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${URL}/quotations`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        data: JSON.stringify(requestData),
      };

      await axios.request(config);
      navigate("/quotation_list")
      setOpen(true);
    } catch (error: any) {
      toast.error(error.response.data.message, {
        position: "bottom-right",
      });
      console.error(error);
    } finally {
      setLoading(false)
    }
  };


  return (
    <div className="container-fluid md:py-9 ">
      <div className="flex flex-row items-center justify-start w-full ml-5">

        <Breadcrumb />
      </div>

      <div className="flex justify-center items-center text-2xl py-4">
        {t("recherche_transporteur")}
      </div>
      <div className="max-w-[95%] mx-auto bg-white shadow-lg shadow-gray-700 rounded-lg p-6">
        <div className="mb-4">
          <p className="text-gray-600">
            {t("remplire_detail")}
          </p>
        </div>

        {/* City input */}
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2">
            {t("ville_depart")}
          </label>
          {/* <input
            type="text"
            placeholder="Entrez la ville"
            className="w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-500"
            value={city}
            onChange={(e) => setCity(e.target.value)}
          /> */}
          <GeoSearch
            geoData={geoData}
            onSelect={handleSelect}
            types={['ADM3']} // Communes uniquement
            placeholder="Ex: Melong, Mbonge, Bafoussam…"
          />
        </div>

        {/* Destination input */}
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2">
            {t("destination")}
          </label>
          <Select
            options={DeliveryUser.map((adress: any) => ({
              value: adress.delivery_id,
              label: adress.delivery_country + "/" + adress.delivery_city + "/" + adress.delivery_address,
            }))}
            value={selectedOption2}
            onChange={(e) => {
              setSelectedOption2(e);
              setDestination(e?.label ?? "")

            }
            }
            placeholder={t("choisir_destination")}
            className="border p-2 rounded w-full"
            isClearable

          />

          {/* ajouter une adresse */}
          <div className="flex justify-center mt-1">
            <CustomButton
              className="flex gap-2 py-2 px-4 bg-white"
              onClick={() => {
                if (!connect) {
                  toast.error(t("connect_vous"))
                  return
                }
                setOpenModal(true)
              }}
            >
              <img
                className="h-[21px] w-[21px]"
                src="/red.svg"
                alt=""
              />
              <span>{t("ajouter_addresse")}</span>
            </CustomButton>
          </div>
        </div>



        {/* Delai */}
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2">
            {t("delai")}
          </label>
          <input
            type="text"
            placeholder="Délai en jour"
            className="w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-500"
            value={delai}
            onChange={(e) => setDelais(e.target.value)}
          />
        </div>

        {/* Latest Departure Date */}
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2">
            {t("date_depart")}
          </label>
          <input
            type="datetime-local"
            className="w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-500"
            value={latestDepartureDate}
            onChange={(e) => setLatestDepartureDate(e.target.value)}
          />
        </div>

        {/* Latest Arrival Date */}
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2">
            {t("date_arrivee")}
          </label>
          <input
            type="datetime-local"
            className="w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-500"
            value={latestArrivalDate}
            onChange={(e) => setLatestArrivalDate(e.target.value)}
          />
        </div>
        {
          order?.products.length ?
            <div>
              <div className=" text-center font-[700] ">
                {t("mes_produits")}
              </div>

              {
                order.products.map((product: any) => {
                  return <div className="flex flex-row items-center ">
                    <div className=" text-[12px] mr-2 font-[700] ">
                      {t("product_name")}
                    </div>
                    : {product.product_name}
                  </div>
                })
              }
            </div> : ""
        }

        {/* Additional products form */}
        {showProductForm &&
          anotherOrderDetails.map((detail, index) => (
            <div key={index} className="border p-4 mb-4 rounded">
              <h4 className="text-lg mb-2 flex justify-between">{t("produit")} {index + 1}
                <div className=" cursor-pointer " onClick={() => {
                  const newDetails = [...anotherOrderDetails];
                  newDetails.splice(index, 1);
                  setAnotherOrderDetails(newDetails);
                }} >
                  <Trash2 color="red" />
                </div>
              </h4>
              <div className="mb-2">
                <label className="block mb-1">{t("nom_produit")}</label>
                <input
                  type="text"
                  className="border p-2 rounded w-full"
                  value={detail.another_product_name}
                  onChange={(e) =>
                    handleAnotherOrderDetailsChange(
                      index,
                      "another_product_name",
                      e.target.value
                    )
                  }
                />
              </div>
              <div className="mb-2">
                <label className="block mb-1">{t("quantite")}</label>
                <input
                  type="text"
                  className="border p-2 rounded w-full"
                  value={detail.another_product_quantity}
                  onChange={(e) =>
                    handleAnotherOrderDetailsChange(
                      index,
                      "another_product_quantity",
                      e.target.value
                    )
                  }
                />
              </div>
              <div className="mb-2">
                <label className="block mb-1">{t("type_product")}</label>
                {loader ? `${t("chargement_uml")}` :
                  <Select<{ value: string; label: string }>
                    options={unites.map((unite: any) => ({
                      value: unite.measurement_type,
                      label: unite.measurement_type + "/" + unite.description,
                    }))}
                    value={{
                      value: detail.another_product_type,
                      label: detail.another_product_type
                    }}
                    // value={selectedOption}
                    onChange={(e) => {
                      // setSelectedOption(e);
                      handleAnotherOrderDetailsChange(
                        index,
                        "another_product_type",
                        e?.value ?? ""
                      )
                    }
                    }
                    placeholder={t("choisir_mesure")}
                    className="border p-2 rounded w-full"
                    isClearable

                  />
                }

              </div>
            </div>
          ))}

        <div className="flex mt-4 text-[white] p-1 rounded-sm bg-slate-400 hover:bg-slate-500 justify-center">
          <button
            onClick={() => {
              if (!connect) {
                toast.error(t("connect_vous"))
                return
              }
              addAnotherProduct()
            }}
          >
            {t("ajouter_autre_produit")}
          </button>
        </div>


        {/* Submit Button */}
        <div className="mt-6">
          <Button
            onClick={handleSubmit}
            disabled={loading}
            className="w-full p-2 bg-green-600 text-white rounded-lg"
          >
            {loading ? "chargement..." : "Soumettre"}
          </Button>
        </div>
      </div>


      {
        openMoal &&
        // eslint-disable-next-line
        <Add_address_modal openMoal={openMoal} setOpenModal={setOpenModal} />
      }

      {/* Dialog */}
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogTrigger asChild></DialogTrigger>
        <DialogContent>
          <DialogDescription>
            <p>{t("demande_success")} !</p>
          </DialogDescription>
        </DialogContent>
      </Dialog>
      <ToastContainer />
    </div>
  );
};

export default RecherTrans;
